<template>
  <v-card max-width="300" height="450" style="margin-top:20px !important;" >
       <v-card-title>
      <v-text-field class="mt-3"
            label="Enter your Location"
            v-model="query"
            @keypress="fetchWeather"
            prepend-inner-icon="mdi-map-marker"
          ></v-text-field>
          </v-card-title>
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="text-h4">
          {{weather.name}}, {{weather.sys.country}}
        </v-list-item-title>
        <v-list-item-subtitle>{{dateBuilder()}}</v-list-item-subtitle>
        <v-list-item-title class="text-h5">{{weather.weather[0].main}}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-card-text>
      <v-row align="center">
        <v-col
          class="text-h4"
          cols="6"
        >
          {{Math.round(weather.main.temp)}}&deg;C
        </v-col>
        <v-col cols="6">
          <v-img
            :src="'http://openweathermap.org/img/wn/'+weather.weather[0].icon+'@2x.png'"
            alt="Sunny image"
            width="92"
          ></v-img>
        </v-col>
      </v-row>
    </v-card-text>

    <v-list-item>
      <v-list-item-icon>
        <v-icon>mdi-weather-windy</v-icon>
      </v-list-item-icon>
      <v-list-item-subtitle>{{weather.wind.speed}} m/s</v-list-item-subtitle>
    </v-list-item>

    <v-list-item>
      
    </v-list-item>


    

    
  </v-card>
</template>

<script>
import moment from 'moment';
  export default {
    name: 'Weather',

    data: () => ({
      api_key: 'd7b8e164e93545099bc5803b1c156e9e',
      url_base: 'https://api.openweathermap.org/data/2.5/',
      query:'Delhi',
      weather:[],
      
    }),
    created () {
      this.fetchWeather('Enter');
    },
    methods:{
        fetchWeather(e){
            if(e.key=="Enter"){
                fetch(`${this.url_base}weather?q=${this.query}&units=metric&lang=en&APPID=${this.api_key}`).then(
                    res => {
                        return res.json();
                    }).then(this.setResults);
            }else if(this.query=="Delhi"){
                fetch(`${this.url_base}weather?q=${this.query}&units=metric&lang=en&APPID=${this.api_key}`).then(
                    res => {
                        return res.json();
                    }).then(this.setResults);
            }     
            
        },
        setResults(results){
            this.weather = results;
        },
        dateBuilder(){
            var d = new Date();
            return  moment(d).format('llll');
        }
    }
  }
</script>
